<template>
  <q-card flat>
    <ListCardTableViewTradingView
      :tableTitle="'Dow Signal Alert Status'"
      :timePeriod="timePeriod"
      :buttonBuyOrSell="buttonBuyOrSell"
      :buyData="DowSignalDataComputed"
      :sellData="DowSignalSellDataComputed"
      :alertOrSignal="'Alert'"
      @selectedSymbol="(s) => (symbolSelected = s)"
    />
  </q-card>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";
import useData from "src/use/data";

import ListCardTableViewTradingView from "src/components/TradingSignalsAndType/StockWiseListCardTableViewTradingView.vue";

const props = defineProps({
  symbol: {
    type: String,
  },
  timePeriod: {
    type: String,
  },
  buttonBuyOrSell: {
    type: String,
  },
});

const $q = useQuasar();

const { DowSignalAlertDaily, DowSignalAlertSellDaily } = useData();

const symbolSelected = ref(null);

const DowSignalData = ref([]);
const DowSignalSellData = ref([]);

async function loadData(apiFunction, dataValue) {
  $q.loading.show({});
  try {
    const res = await apiFunction(90);
    dataValue.value = res.data;
    $q.loading.hide();
  } catch (error) {
    console.log(error);
  } finally {
    $q.loading.hide();
  }
}

function updateDataBasedOnTimePeriod(timePeriodValue) {
  if (timePeriodValue === "daily") {
    loadData(DowSignalAlertDaily, DowSignalData);
    loadData(DowSignalAlertSellDaily, DowSignalSellData);
  }
}

const DowSignalDataComputed = computed(() => {
  return DowSignalData.value.filter((item) => item.symbol === props.symbol);
});

const DowSignalSellDataComputed = computed(() => {
  return DowSignalSellData.value.filter((item) => item.symbol === props.symbol);
});

watch(
  () => props.timePeriod,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(newVal);
  }
);

onMounted(() => {
  updateDataBasedOnTimePeriod(props.timePeriod);
});
</script>
